import { render, staticRenderFns } from "./PlannedServiceDetails.vue?vue&type=template&id=5b1d3679&"
import script from "./PlannedServiceDetails.vue?vue&type=script&lang=js&"
export * from "./PlannedServiceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports